import { put } from 'redux-saga/effects'
import { fetchUser } from 'Redux/actions/user'

export default function*(action) {
  yield put(fetchUser())
}
